import { render, staticRenderFns } from "./UserLanguage.vue?vue&type=template&id=b0bf4b9a&"
import script from "./UserLanguage.vue?vue&type=script&lang=js&"
export * from "./UserLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0bf4b9a')) {
      api.createRecord('b0bf4b9a', component.options)
    } else {
      api.reload('b0bf4b9a', component.options)
    }
    module.hot.accept("./UserLanguage.vue?vue&type=template&id=b0bf4b9a&", function () {
      api.rerender('b0bf4b9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/home/UserLanguage.vue"
export default component.exports